




import { Component, Vue, Prop } from 'vue-property-decorator';
import config from '@/config';

@Component
export default class AppLogo extends Vue {
  @Prop({
    type: String,
    default: '/img'
  })
  path?: String;

  @Prop({
    type: String,
    default: ''
  })
  variant?: string;

  @Prop(String) title?: string;

  @Prop({
    type: Boolean,
    default: false
  })
  vector?: boolean;

  get logo(): String {
    return `${this.path}/logo${this.logoVariant}.${this.extension}`;
  }

  get extension(): String {
    if (this.vector) {
      return 'svg';
    }
    return 'png';
  }

  get logoVariant(): String {
    if (this.variant) {
      return `-${this.variant}`;
    }
    return '';
  }

  get altText(): string {
    if (!this.title) {
      return config.getAppTitle();
    }
    return this.title;
  }
}
